/*
 * BBC - Rap Map - Map custom marker
 *
 * @author Matt Haynes <matt@joipolloi.com>
 * @package BBC Rap Map
 */

import React from 'react';
import { Marker, FlyToInterpolator } from 'react-map-gl';

import GoldMic from './assets/MIC-Contestant-season3-potw.png';
import micImage from './assets/MIC.png';
import micContestantImage from './assets/MIC-Contestant.png';
import micContestantImage3 from './assets/MIC-Contestant-season3.png';
import ClusterBackground from './assets/cluster-background.svg';

const CustomMarker = ({
    index,
    longitude,
    season,
    latitude,
    pointCount,
    isCluster = false,
    onClick: openPopup = () => null,
    location,
    setViewport,
    viewport,
    isContestant,
    imageURL,
    pickOfTheWeek,
}) => {
    const updateViewport = () => {
        setViewport && setViewport({
            ...viewport,
            latitude,
            longitude,
            transitionInterpolator: new FlyToInterpolator({ speed: 1 }),
            transitionDuration: 'auto',
        })
    };

    let micForContestant;
    if (imageURL && pickOfTheWeek) {
        micForContestant = GoldMic;
    } else if (season === 3) {
        micForContestant = micContestantImage3;
    } else {
        micForContestant = micContestantImage;
    }

    return (
        <Marker
            className={`Map__Marker ${pickOfTheWeek ? 'Map__Marker--rapperOfTheWeek' : ''}`}
            longitude={longitude}
            latitude={latitude}
            key={index}
            captureDrag={false}
        >
            <button
                aria-label={`Map Marker ${location ? location : ''}`}
                tabIndex="0"
                className="marker"
                onMouseDown={() => { openPopup(index); updateViewport(); }}
                onFocus={updateViewport}
                onClick={() => { openPopup(index); updateViewport(); }}
            >
                <span>
                    {isCluster ? <span className="marker-count" style={{ backgroundImage: `url(${ClusterBackground})` }}>+{pointCount}</span> : ''}
                    <img src={isContestant ? micForContestant : micImage} alt="" />
                </span>
            </button>
        </Marker>
    );
};

export default CustomMarker;
